import { tExtWindow } from "@src/types"
import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

/**
 * Hook to track GA4 page views for SPA navigation.
 * Handles ALL page views (initial load + route changes) because GA4 is configured
 * with send_page_view: false to support manual SPA tracking.
 *
 * Tracks page_referrer to maintain proper attribution across SPA navigations.
 * For the first page, uses document.referrer (external referrer).
 * For subsequent pages, uses the previous internal URL.
 *
 * Call once in the Routes component.
 *
 * See: https://developers.google.com/analytics/devguides/collection/ga4/single-page-applications
 */
export const usePageTracking = () => {
  const location = useLocation()
  const extWindow = window as unknown as tExtWindow
  const previousUrl = useRef<string>(document.referrer)

  useEffect(() => {
    const currentUrl = window.location.href

    if (extWindow.gtag) {
      extWindow.gtag("event", "page_view", {
        page_title: document.title,
        page_location: currentUrl,
        page_referrer: previousUrl.current,
      })
    }

    // Store current URL as referrer for the next navigation
    previousUrl.current = currentUrl
  }, [location.pathname])
}
